// In our transition to React, we have code paths that might execute an RTK Query mutation that changes something
// on the $rootScope.currentUser Iguana object.
// RTK Query mutations will not execute our $http interceptors, which are typically responsible for catching updates
// in-flight and mutating the user accordingly.
// This module exposes a similar behavior for any RTK Query mutation that needs to ensure the $rootScope.currentUser Iguana object
// is updated with anything coming back from the server.

import transformKeyCase from 'Utils/transformKeyCase';
import { pushUpdatedPropertiesOntoCurrentUserIguanaObject } from './pushUpdatedPropertiesOntoCurrentUserIguanaObject';

// Controllers control what they do or not add to push messages, so accurate typing is almost impossible here.
type CurrentUserPushMessagesAttrs = Record<string, unknown>;

// If we find that we're needing to do this a lot as we migrate more code from Iguana to RTKQ wrt. API calls, we should at least consider
// moving this into Redux middleware, which would approximate an HTTP interceptor.
export const transformResponseWithCurrentUserPushMessages = (pushMessages: {
    currentUser: CurrentUserPushMessagesAttrs;
}): void => {
    // buildRtkQueryBaseBackRoyalQueryFn / convertQueryCasing will automatically camelCase server responses, we're undoing that conversion here to feed
    // it back into the CurrentUserIguanaObject.
    const snakeCasedPushMessages: { current_user: CurrentUserPushMessagesAttrs } = transformKeyCase(pushMessages, {
        to: 'snakeCase',
    });
    pushUpdatedPropertiesOntoCurrentUserIguanaObject(snakeCasedPushMessages.current_user, true);
};
